import React, { FC } from "react";
import { Alert } from "react-bootstrap";
import "./style.css";
import LButtonClose from "components/LButtonClose";

export interface AlertComponentProps {
  variant?: "danger" | "info" | "success" | "warning";
  description?: string;
  onClose?: () => void;
  className?: string;
}

const icon = (variant?: "danger" | "info" | "success" | "warning") => {
  switch (variant) {
    case "danger":
      return <i className="fa fa-frown-o pe-4"></i>;
    case "info":
      return <i className="fa fa-bell-o pe-4"></i>;
    case "success":
      return <i className="fa fa-check-circle-o pe-4"></i>;
    case "warning":
      return <i className="fa fa-exclamation pe-4"></i>;
    default:
      return null;
  }
};

const descriptionDefault = (
  variant?: "danger" | "info" | "success" | "warning",
) => {
  switch (variant) {
    case "danger":
      return "Perigo";
    case "info":
      return "Informação";
    case "success":
      return "Sucesso";
    case "warning":
      return "Alerta";
    default:
      return "";
  }
};

const AlertComponent: FC<AlertComponentProps> = ({
  variant = "info",
  description,
  onClose,
  className,
}) => {
  return (
    <div className="d-flex align-items-center justify-content-end h-100 w-100 pe-4">
      <Alert
        variant={variant}
        className={`slide-in-right ${className} d-flex align-items-center justify-content-between`}
      >
        <div className="d-flex align-items-center">
          {icon(variant)}
          <div className="me-3 text-left">
            {description ? description : descriptionDefault(variant)}
          </div>
        </div>
        <LButtonClose onClick={onClose}/>
      </Alert>
    </div>
  );
};

export default AlertComponent;
